var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 5.13672C5.56062 5.13672 5 5.69734 5 6.38672C5 7.07609 5.56062 7.63672 6.25 7.63672C6.93937 7.63672 7.49875 7.07859 7.49875 6.38922C7.49875 5.69984 6.93937 5.13672 6.25 5.13672ZM6.25 8.88672C4.87125 8.88672 3.75 7.76547 3.75 6.38672C3.75 5.00797 4.87125 3.88672 6.25 3.88672C7.62875 3.88672 8.75 5.00797 8.75 6.38672C8.75 7.76547 7.62875 8.88672 6.25 8.88672Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.63281V8.84656L11.2862 17.6328L17.5 11.4191L8.71375 2.63281H2.5ZM10.4025 18.5166L1.61625 9.72969C1.38187 9.49531 1.25 9.17781 1.25 8.84594V2.63281C1.25 1.94219 1.80937 1.38281 2.5 1.38281H8.71313C9.045 1.38281 9.3625 1.51469 9.59687 1.74906L18.3837 10.5353C18.6306 10.7816 18.7525 11.1053 18.75 11.4291C18.7475 11.7453 18.6256 12.0616 18.3837 12.3028L12.17 18.5172C11.9288 18.7584 11.6125 18.8803 11.2963 18.8828C10.9725 18.8853 10.6488 18.7634 10.4025 18.5166Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.997e65e89f6a6d00b2affad823066594.svg";
export { ForwardRef as ReactComponent };